// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#outing-setting[data-v-56eab9db]{max-width:820px;margin-left:auto;margin-right:auto}#outing-setting .box-header .title[data-v-56eab9db]{font-size:22px;font-weight:700}#outing-setting .cancel-btn[data-v-56eab9db],#outing-setting .update-btn[data-v-56eab9db]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
